import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "form"]

  show() {
    this.formTarget.hidden = false
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.formTarget.querySelector("input:not([type=hidden])")?.focus()
  }

  hide() {
    this.formTarget.hidden = true
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.toggleTarget.focus()
  }
}
